import React, { Component } from "react";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse,
} from "mdbreact";
import { BrowserRouter as Router } from 'react-router-dom';
import "./navi.css";

class Navi extends Component {
state = {
  isOpen: false
};

toggleCollapse = () => {
  this.setState({ isOpen: !this.state.isOpen });
}

render() {
  return (
    <Router>
      <MDBNavbar color="default-color" className="fixed-top" light expand="md">
        <MDBNavbarBrand>
          <strong className="dark-text">Ahmet Aksu</strong>
        </MDBNavbarBrand>
        <MDBNavbarToggler onClick={this.toggleCollapse} />
        <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
          <MDBNavbarNav right>
            <MDBNavItem active>
              <a  href="#home" className="link">Home</a>
            </MDBNavItem>
            <MDBNavItem>
              <a  href ="#about" className="link">About</a>
            </MDBNavItem>
            <MDBNavItem>
              <a  href ="#exp" className="link">Studies</a>
            </MDBNavItem>
            <MDBNavItem>
              <a href="#courses" className="link">Courses</a>
            </MDBNavItem>
            <MDBNavItem>
              
            </MDBNavItem>
          </MDBNavbarNav>
          
        </MDBCollapse>
      </MDBNavbar>
    </Router>
    );
  }
}

export default Navi;